import z from "zod/v4";
import { BalanceTransactionDataSchema } from "./balance-transaction-data";

export const OutboundInvoiceSchema = z.object({
  key: z.number(),
  pending: z.boolean(),
  startDate: z.date(),
  endDate: z.date().nullish(),
  transactions: z.array(BalanceTransactionDataSchema),
});

export type OutboundInvoice = z.infer<typeof OutboundInvoiceSchema>;
